import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { formatDistanceToNow } from 'date-fns';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useClipboard } from '../hooks/useClipboard';

const { FiCopy, FiCheck, FiClock } = FiIcons;

const ClipboardItem = ({ item, index }) => {
  const [copied, setCopied] = useState(false);
  const { copyToClipboard } = useClipboard();

  const handleCopy = async () => {
    const success = await copyToClipboard(item.content);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const truncateText = (text, maxLength = 100) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Handle both formats - the one from the database and the one from local state
  const content = item.content;
  const timestamp = item.timestamp;
  const deviceName = item.device_name || item.deviceName;

  return (
    <motion.div
      className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-all duration-200"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      layout
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="text-gray-900 text-sm leading-relaxed break-words">
            {content && content.length > 100 ? (
              <details className="group">
                <summary className="cursor-pointer hover:text-primary-600 transition-colors">
                  {truncateText(content)}
                  <span className="text-primary-600 ml-1 group-open:hidden">Show more</span>
                </summary>
                <div className="mt-2 text-gray-800">
                  {content}
                </div>
              </details>
            ) : (
              content
            )}
          </div>
          <div className="flex items-center gap-2 mt-3 text-xs text-gray-500">
            <SafeIcon icon={FiClock} className="w-3 h-3" />
            <span>
              {timestamp ? formatDistanceToNow(new Date(timestamp), { addSuffix: true }) : 'Just now'}
            </span>
            {deviceName && (
              <>
                <span>•</span>
                <span>from {deviceName}</span>
              </>
            )}
          </div>
        </div>
        <motion.button
          onClick={handleCopy}
          className={`flex-shrink-0 p-2 rounded-lg transition-all duration-200 ${
            copied ? 'bg-success-100 text-success-600' : 'bg-gray-100 text-gray-600 hover:bg-primary-100 hover:text-primary-600'
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <SafeIcon icon={copied ? FiCheck : FiCopy} className="w-4 h-4" />
        </motion.button>
      </div>
    </motion.div>
  );
};

export default ClipboardItem;